class Alert {
  private alert: HTMLElement;
  private closeButton: HTMLButtonElement;

  constructor(element: HTMLElement) {
    this.alert = element;
    this.closeButton = this.alert.querySelector('.close-alert');
    this.init();
  }

  init() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.handleClick.bind(this));
    }
  }

  handleClick(event) {
    event.preventDefault();
    this.alert.classList.add('hide');
  }
}

document.querySelectorAll('.alert').forEach((alert) => {
  new Alert(alert as HTMLElement);
});
